import axios from "axios";
import { baseUrl } from "./baseUrl";

const token = localStorage.getItem('token');

const api = axios.create({
    baseURL: `${baseUrl}/admin/user`,
    headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
    },
});

//     try {
//         const response = await api.get("/rejection-reasons-list");
//         return response.data.rejectionReasons || [];
//     } catch (error) {
//         console.error("Error fetching rejection reasons:", error);
//         throw error;
//     }
// }

// export const createRejectionReason = async (reason) => {
//     try {
//         const response = await api.post(`/rejection-reasons/create`, {
//             reason: reason
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Error creating rejection reason:", error);
//         throw error;
//     }
// }

// export const updateRejectionReason = async (reasonId, reason) => {
//     try {
//         const response = await api.put(`/rejection-reasons/update/${reasonId}`, {
//             reason: reason
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Error deleting user review:", error);
//         throw error;
//     }
// }

// Issue Categories
export const addIssueCategory = async (categoryData) => {
    try {
        const response = await api.post("/add-issue-categories", categoryData);
        return response.data;
    } catch (error) {
        console.error("Error adding issue category:", error);
        throw error;
    }
};

export const getIssueCategories = async () => {
    try {
        const response = await api.get("/get-issue-categories");
        return response.data || [];
    } catch (error) {
        console.error("Error fetching issue categories:", error);
        throw error;
    }
};

export const viewIssueCategories = async (id) => {
    try {
        const response = await api.get(`/view-issue-categories/`, { params: { id } });
        return response.data.issueCategories || [];
    } catch (error) {
        console.error("Error viewing issue categories:", error);
        throw error;
    }
};

export const editIssueCategory = async (categoryId, categoryData) => {
    try {
        const response = await api.put(`/edit-issue-categories`,
             { id: categoryId, ...categoryData },
            {params: {id: categoryId}});
        return response.data;
    } catch (error) {
        console.error("Error editing issue category:", error);
        throw error;
    }
};

export const deleteIssueCategory = async (categoryId) => {
    try {
        const response = await api.delete(`/delete-issue-categories?id=${categoryId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting issue category:", error);
        throw error;
    }
};

// Image Deletion
export const deleteImage = async (imgData) => {
    try {
        const response = await api.post("/delete-img", imgData);
        return response.data;
    } catch (error) {
        console.error("Error deleting image:", error);
        throw error;
    }
};

// Help Requests
export const listHelpRequests = async () => {
    try {
        const response = await api.get("/list-help-requests");
        return response.data.data || [];
    } catch (error) {
        console.error("Error listing help requests:", error);
        throw error;
    }
};

// Get Help Request by ID
export const getHelpRequestById = async (id) => {
    try {
        const response = await api.get(`/get-help?id=${id}`);
        return response.data.data || {};
    } catch (error) {
        console.error("Error fetching help request by ID:", error);
        throw error;
    }
};

// resolve issue conversation
export const resolveIssueConversation = async (data) => {
    try {
        const response = await api.post(`/resolve-issue-conversation`, data);
        return response.data;
    } catch (error) {
        console.error("Error resolving issue conversation:", error);
        throw error;
    }
}

// Messages
export const getHelpMessages = async (id) => {
    try {
        const response = await api.get(`/get-help`, { params: { id } });
        return response.data.messages || [];
    } catch (error) {
        console.error("Error listing messages:", error);
        throw error;
    }
};

export const sendMessage = async (id, message) => {
    try {
        console.log({ id, message });
        const response = await api.post(`/replay-help-message`, { id, message });
        return response.data;
    } catch (error) {
        console.error("Error sending message:", error);
        throw error;
    }
};

// Inquiries
export const getInquiries = async () => {
    try {
        const response = await api.get("/get-inquiries");
        return response.data.data || [];
    } catch (error) {
        console.error("Error fetching inquiries:", error);
        throw error;
    }
};

export const getInquiryDetails = async (id) => {
    try {
        const response = await api.get(`/inquiry-details?id=${id}`);
        return response.data.data || {};
    } catch (error) {
        console.log("Error fetching inquiry-details:", error);
        throw error;
    }
}

export const markInquiryResolved = async (id) => {
    try {
        const response = await api.put(`/mark-inquiry-resolved?id=${id}`);
        return response.data;
    } catch (error) {
        console.error("Error marking inquiry as resolved:", error);
        throw error;
    }
}